import {useCallback, useEffect, useState} from "react";

interface ConsentStatus {
    [service: string]: boolean | undefined;
}

// Define services that require a reload when their consent is withdrawn
const servicesThatRequireReload = ["Google Tag Manager", "Visual Website Optimizer (VWO)"];


const useHandleScripts = () => {
    const [previousConsentStatus, setPreviousConsentStatus] = useState<ConsentStatus>({});

    const checkAndReloadOnConsentWithdrawal = useCallback(
        (serviceName: string, consentStatus: ConsentStatus) => {
            const previousConsent = previousConsentStatus[serviceName];
            const currentConsent = consentStatus[serviceName];

            if (previousConsent !== undefined && currentConsent !== undefined) {
                if (previousConsent !== currentConsent && !currentConsent) {
                    window.location.reload();
                }
            }
        },
        [previousConsentStatus]
    );

    useEffect(() => {
        const handleConsentStatus = (e: CustomEvent<ConsentStatus>) => {
            const consentDetails = e.detail;

            if (consentDetails["YouTube Video"]) {
                document
                    .querySelectorAll<HTMLIFrameElement>(
                        'iframe[data-service="YouTube Video"]'
                    )
                    .forEach((iframe) => {
                        const url = iframe.getAttribute("data-src");
                        if (url) iframe.setAttribute("src", url);
                    });
            }
            servicesThatRequireReload.forEach((service) => {
                checkAndReloadOnConsentWithdrawal(service, consentDetails);
            });
            setPreviousConsentStatus(consentDetails);
        };

        window.addEventListener(
            "consents_initialized",
            handleConsentStatus as EventListener
        );
        window.addEventListener(
            "consents_updated",
            handleConsentStatus as EventListener
        );

        return () => {
            window.removeEventListener(
                "consents_initialized",
                handleConsentStatus as EventListener
            );
            window.removeEventListener(
                "consents_updated",
                handleConsentStatus as EventListener
            );
        };
    }, [previousConsentStatus, checkAndReloadOnConsentWithdrawal]);
};

export default useHandleScripts;